/** AnimatedSprite3D parser: the GeometryInstance3D base and the SpriteBase3D quad placement. */
import { parseGeometryInstance3D } from '../geometryinstance3d/parser';
import { parseSpriteQuad } from '../sprite3d/quadParser';
export function parseAnimatedSprite3D(heading, properties) {
    return {
        ...parseGeometryInstance3D(heading, properties),
        ...parseSpriteQuad(properties, 'AnimatedSprite3D'),
    };
}
//# sourceMappingURL=parser.js.map